export interface Capability {
  title: string
  description: string
}

export const capabilities: Capability[] = [
  {
    title: 'Software development, on-site or off-site',
    description:
      'Desktop, mobile, web, server, cloud, and embedded systems — embedded with your team or delivered independently.',
  },
  {
    title: 'Technology creation through applied research',
    description:
      'State-of-the-art capability built for your problem when nothing off the shelf gets close enough.',
  },
  {
    title: 'Breadth across languages and platforms',
    description:
      'Deep working expertise in numerous programming languages, runtime environments, and development platforms.',
  },
  {
    title: 'Algorithm analysis, design, and implementation',
    description:
      'From complexity analysis and proof sketches through to production implementations your team can maintain.',
  },
  {
    title: 'Performance analysis and tuning',
    description:
      'Profiling and correction across algorithms, memory behavior, runtime configuration, and hardware effects.',
  },
  {
    title: 'Computationally intractable problems',
    description:
      'Heuristics, approximation, and abstraction for problems that are hard, undecidable, or simply resistant.',
  },
]

export const domains: string[] = [
  'National security and intelligence',
  'Finance',
  'Data mining',
  'Text mining and information retrieval',
  'Natural language processing',
  'Biomedical informatics',
  'Games and virtual worlds',
  'Robotics',
  'Brain simulation',
]
